<template>
  <ion-toolbar color="danger">
    <div v-if="error">{{ error }}</div>
    <div class="ion-text-center h-f-m">You have {{ shiftCount }} shifts this month!</div>
  </ion-toolbar>
</template>

<script>
import shiftsApiService from "../services/ShiftsApi";
import moment from "moment";

const paramDateFormat = "YYYY-MM-DD";

export default {
  name: "ShiftNotice",
  data() {
    return {
      startDate: moment()
        .startOf("month")
        .format(paramDateFormat),
      endDate: moment()
        .endOf("month")
        .format(paramDateFormat),
      shiftCount: 0,
      error: false
    };
  },
  mounted() {
    shiftsApiService
      .getShiftCount(this.startDate, this.endDate)
      .then(count => {
        this.shiftCount = count;
      })
      .catch(error => {
        this.error = error;
      });
  }
};
</script>